import { BaseNumericPropertyViewModel } from './base-numeric-property-view-model';
import { PropertyViewModelInitializationInfo } from '../property-view-model-initialization-info';
import { BigNumber } from '@nts/std/types';
import type { NumericPropertyViewModelInterface } from '@nts/std/interfaces';

export class NNumericPropertyViewModel<
    TModelType = BigNumber | number
> extends BaseNumericPropertyViewModel<TModelType> implements NumericPropertyViewModelInterface<TModelType> {

    override getMaskedValue(value: TModelType): string {
        if (typeof value !== 'number' && !BigNumber.isBigNumber(value)) {
            // TODO: we should throw an exception
            return '';
        }
        if (value == null) {
            return '';
        }
        return BaseNumericPropertyViewModel.getMaskedFormattedValue(this);
    }

    constructor(
        initInfo: PropertyViewModelInitializationInfo,
    ) {
        super(initInfo, true);
        this.setFaultBackValue(null);
        this.isNullable = true;
    }
}
